import { Extension, Layers, Palette, RocketLaunch, Share, VerifiedUser } from '@mui/icons-material';

const icons = {
  Layers,
  Share,
  Extension,
  Palette,
  RocketLaunch,
  VerifiedUser,
};

export default icons;
